import React, { useState, useRef, useEffect } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography  } from 'antd';
import {insert, update, getById} from '../../../../apis/TipoConceptoApi';
import Highlighter from "react-highlight-words";
import {clases} from '@app/constants/tipoConcepto';


const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [ID, setID] = useState(id);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    
    const handleOk = async () => {
        const fields = form.getFieldsValue()
        let success = false;
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                ...fields
            }
            const response = await update(payload);
            success = response.ok;
            if(response.ok){
                message.success('Se actualizó correctamente el tipo de concepto!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                ...fields
            }
            const response = await insert(payload);
            success = response.ok;
            if(response.ok){
                setID(response.payload);
                message.success('Se guardo correctamente el periodo!');
            }
        }

        if(success){
            setModified(true)
            finish(true, true);
        }
    }

    const onClose = ()=>{
        finish(modified);
        setInitialValues(null);
    }

    const effectRan = useRef(false);
    useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          if(ID > 0){
            await refreshData();
          }else{
              setInitialValues({
                  tipo: '',
                  descripcion: '',
                  clase: '0',
              });
          }
          setModified(false)
        })();
      }
      return () => effectRan.current = true;
    }, []);

    const refreshData = async ()=> {
        const response = await getById(ID);
        if(response.ok){
          let periodo = response.payload;
          setInitialValues(periodo);
        }
    }

    return (
        <Drawer
        title={<>
            {title}
        </>}
            width={720}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            extra={[
            <Space>
                {ID && <InfoTracking entity={'TipoConcepto'} entityId={ID}/>}
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>
            ]}
        >
            <>
              <div style={{height: 50}}>
                  <div style={{float: 'left'}}>
                      <span title=""></span>
                  </div>
                  <span class="" style={{float:'right'}}>
                      
                  </span>
              </div>
              {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
              <Space>
                  <Button onClick={onClose}>Cancelar</Button>
                  <Button onClick={handleOk} type="primary">
                  Guardar
                  </Button>
              </Space>]} />*/}
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark initialValues={initialValues} onFinish={handleOk}>
                <Row gutter={16}>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                          <Form.Item
                              name="tipo"
                              label="Tipo"
                              rules={[
                              {
                                  required: true,
                                  message: 'Por favor agrega un tipo',
                              },
                              ]}
                          >
                              <Input disabled={ID > 0} placeholder="Por favor agrega un tipo" />
                          </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="descripcion"
                            label="Descripción"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega una descripción',
                            },
                            ]}
                        >
                            <Input placeholder="Por favor agrega una descripción" />
                        </Form.Item>
                    </Col>
                    <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                              name="clase"
                              label="Clase"
                              rules={[
                              {
                                  required: true,
                                  message: 'Por favor selecciona una clase',
                              },
                              ]}
                              
                          >
                            <Select disabled={ID > 0} placeholder="Por favor selecciona una clase">
                                {
                                    clases.list.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
          }
        </>
      </Drawer>
  );
};
export default App;